import React from 'react';
import { SnackbarContent, CustomContentProps } from 'notistack';
import { Box, Typography } from '@mui/material';

interface SnackbarSuccessProps extends CustomContentProps {
  message: string;
}

const SnackbarSuccess = React.forwardRef<HTMLDivElement, SnackbarSuccessProps>(
  (props, ref) => {
    const { id, message, ...other } = props;

    return (
      <SnackbarContent
        ref={ref}
        id={id.toString()}
        {...other}
        style={{
          background: '#2C2C2C',
          borderRadius: '8px',
          padding: '16px',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            textAlign: 'right',
          }}
        >
          <Typography
            fontFamily="AlmoniDl"
            fontWeight="700"
            dir="rtl"
            style={{
              color: '#fff',
            }}
          >
            {message}
          </Typography>
        </Box>

        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: '4px',
            background: '#B6F828',
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: '8px',
          }}
        />
      </SnackbarContent>
    );
  },
);

export default SnackbarSuccess;
